import React, { useEffect, useRef, useState } from 'react';
import { withTheme } from '@rneui/themed';
import { useCollectionItemQuery } from '@annunciate/query';
import { usePlaylistStateStore, } from '@annunciate/core';
import { PlaybackStateFilter, DisplayMode } from '@annunciate/core';
import { DefaultListHeader, } from '@annunciate/ui/dist/components/collection/mode/Series/DefaultListHeader';
import { SeriesFlatlist, } from '@annunciate/ui/dist/components/collection/mode/Series/SeriesFlatlist';
import { COLLECTION_ITEMS_SERIES } from '../../../../utils/mocks';
const { setAvailablePlaylistContext } = usePlaylistStateStore.getState();
export const UnthemedSeries = ({ collection, listItemContainerStyle, ListHeader = DefaultListHeader, }) => {
    const refId = useRef(collection.id);
    const [filter, setFilter] = useState({
        collection: collection,
        playbackState: PlaybackStateFilter.ALL,
    });
    useEffect(() => {
        if (refId.current !== collection.id) {
            setFilter({ ...filter, collection: collection });
            refId.current = collection.id;
        }
    }, [collection.id, refId.current]);
    const { isPending, isFetchingNextPage, isFetchingPreviousPage, hasNextPage, data, fetchNextPage, } = useCollectionItemQuery({
        parentId: filter.collection.id,
        displayMode: DisplayMode.SERIES,
        filter,
        shouldObserveUser: collection.isUserDependent,
    });
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    useEffect(() => {
        if (filter)
            setAvailablePlaylistContext(filter);
    }, [JSON.stringify(filter)]);
    let items = data;
    if (isLoadingPage && data.length > 0) {
        items = [
            ...data,
            COLLECTION_ITEMS_SERIES[0],
        ];
    }
    else if (isPending && data.length === 0) {
        items = COLLECTION_ITEMS_SERIES;
    }
    return (React.createElement(SeriesFlatlist, { items: items, onEndReached: () => {
            if (hasNextPage)
                fetchNextPage();
        }, listItemContainerStyle: listItemContainerStyle, ListHeaderComponent: React.createElement(ListHeader, { collection: collection, filter: filter, setFilter: setFilter, containerStyle: listItemContainerStyle }) }));
};
export const Series = withTheme(UnthemedSeries, 'Series');
//# sourceMappingURL=Series.js.map